import type { RouteRecordRaw } from 'vue-router'

const ExpensesPage = () => import('./pages/ExpensesPage.vue')

const expenseRoutes: RouteRecordRaw[] = [
  {
    name: 'finance-expenses',
    path: 'expenses',
    component: ExpensesPage,
    meta: { requiresAuth: true },
  },
]

export default expenseRoutes
